import { render, staticRenderFns } from "./BrandRank.vue?vue&type=template&id=14ead6e4&scoped=true"
import script from "./BrandRank.vue?vue&type=script&lang=js"
export * from "./BrandRank.vue?vue&type=script&lang=js"
import style0 from "./BrandRank.vue?vue&type=style&index=0&id=14ead6e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14ead6e4",
  null
  
)

export default component.exports